import _classCallCheck from "/var/app/current/WebApp/node_modules/@babel/runtime/helpers/esm/classCallCheck";

// The photo model
var Photo = function Photo(_ref) {
  var _ref$quality = _ref.quality,
      quality = _ref$quality === void 0 ? 0.75 : _ref$quality,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 2 : _ref$size,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 1920 : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 1920 : _ref$maxHeight,
      _ref$resize = _ref.resize,
      resize = _ref$resize === void 0 ? true : _ref$resize,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === void 0 ? false : _ref$rotate;

  _classCallCheck(this, Photo);

  this.start = window.performance.now();
  this.end = null;
  this.alt = null;
  this.ext = null;
  this.startSize = null;
  this.startWidth = null;
  this.startHeight = null; // size in MB

  this.size = size * 1000 * 1000;
  this.endSize = null;
  this.endWidth = null;
  this.endHeight = null;
  this.iterations = 0;
  this.base64prefix = null;
  this.quality = quality;
  this.resize = resize;
  this.maxWidth = maxWidth;
  this.maxHeight = maxHeight;
  this.orientation = 1;
  this.rotate = rotate;
};

export default Photo;